import { Box, Typography } from '@mui/material';
import { num } from '../format';
import { COLORS } from '../theme';

/**
 * Colour-scale legend, rendered as HTML rather than by chartjs-chart-geo — its
 * in-canvas legend draws inside the plot area, where it either clipped off the
 * edge or lost its maximum tick.
 *
 * The gradient mirrors Chart.js's `interpolate: 'oranges'` so it matches the fills.
 */
const MapLegend = ({ max }: { max: number }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end', pr: 1, pt: 0.5 }}>
    <Typography variant='caption' sx={{ color: COLORS.muted }}>
      0
    </Typography>
    <Box
      sx={{
        width: 140,
        height: 8,
        borderRadius: 1,
        background: 'linear-gradient(to right, #fff5eb, #fd8d3c, #7f2704)',
      }}
    />
    <Typography variant='caption' sx={{ color: COLORS.muted, fontWeight: 600 }}>
      {num(max)}
    </Typography>
  </Box>
);

export default MapLegend;
